import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { Project } from '@/types/store-types';
import { ProjectStatus } from '@/types/crm-types';

@Component
export default class ProjectOverview extends Vue {
  @Prop()
  private line: Project;

  private linktoproject() {
    this.$router.push({ name: 'project', params: { projectId: this.line.projectId } });
  }

  private startDate(): string {
    return `${this.$dayjs(this.line.startDate).format('DD-MM-YYYY')}`;
  }

  private endDate(): string {
    if (this.line.endDate) {
      return `${this.$dayjs(this.line.endDate).format('DD-MM-YYYY')}`;
    }

    return '';
  }

  get status(): string {
    switch (this.line.status) {
      case ProjectStatus.Concept:
        return this.$t('status.concept').toString();
      case ProjectStatus.InProgress:
        return this.$t('status.inprogress').toString();
      case ProjectStatus.Completed:
        return this.$t('status.completed').toString();
      default:
        return this.$t('status.unknown').toString();
    }
  }
}
